import { UIHeading1, UIHeading3, UIText1 } from '@cian/ui-kit';
import clsx from 'clsx';
import * as React from 'react';

import * as styles from './styles.css';
import { IHowItWorkProps } from './types';

export const HowItWork: React.FC<IHowItWorkProps> = ({ content, howItWorkRef, uiTheme = 'var(--theme-white)' }) => {
  const colorText = uiTheme === 'var(--theme-white)' ? 'theme-dark' : 'theme-white';

  return (
    <div
      ref={howItWorkRef}
      className={clsx(styles['container'], { [styles['black']]: uiTheme === 'var(--theme-black)' })}
    >
      <div className={styles['title']}>
        <UIHeading1 color={colorText}>Как всё работает</UIHeading1>
      </div>
      <div className={styles['steps-first']}>
        {content.first.map((item, index) => {
          return (
            <div key={index} className={styles['step']}>
              <div className={styles['img']} style={{ backgroundImage: `url(${item.img})` }} />
              <div className={styles['step-title']}>
                <UIHeading3 color={colorText}>{item.title}</UIHeading3>
              </div>
              <UIText1 color={colorText}>{item.text}</UIText1>
            </div>
          );
        })}
      </div>
      <div className={styles['steps-last']}>
        {content.last.map((item, index) => {
          return (
            <div key={index} className={styles['step']}>
              <div className={styles['img']} style={{ backgroundImage: `url(${item.img})` }} />
              <div className={styles['step-title']}>
                <UIHeading3 color={colorText}>{item.title}</UIHeading3>
              </div>
              <UIText1 color={colorText}>{item.text}</UIText1>
            </div>
          );
        })}
      </div>
    </div>
  );
};

HowItWork.displayName = 'HowItWork';
